var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup33X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.489 20.4243H0.0229492V21H25.489V20.4243Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5121 17.3734H0L0.0230111 10.4425L9.42461 6.59705L14.5684 10.1892L25.5005 0V17.3849L25.5121 17.3734ZM0.575373 16.7977H24.9367V1.3125L14.626 10.9145L9.35557 7.24181L0.598384 10.8224L0.575373 16.7862V16.7977Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.5V17H25V1L14.5 10.5L9.5 7L0.5 10.5Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33X);
export default __webpack_public_path__ + "static/media/Group33x.a1d4e2719646ce59ce853414a550feeb.svg";
export { ForwardRef as ReactComponent };